// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".external-link--button{gap:var(--space-xs)}", "",{"version":3,"sources":["webpack://./src/components/common/ui-widgets/external-link.scss"],"names":[],"mappings":"AAGI,uBACI,mBAAA","sourcesContent":["@import 'styles/mixins.scss';\n\n.external-link {\n    &--button {\n        gap: var(--space-xs);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
